import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var minDate = new Date('2020-01-01');
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(yesterday).format('MM/DD/YYYY');
var start_date_limit = moment(minDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
class IdownloadReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            is_issuer_loading: true,
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isChange: false,
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            dateFromLimit: start_date_limit,
            productTypeLists: [],
            productTypeIDs: '',
            productTypeValue: {value: '', label: 'All'},
            versionLists: [],
            versionIDs: '',
            versionValue: null,
            pr_versionIDs: '',
            pr_versionValue: null,
            upg_versionIDs: '',
            upg_versionValue: null,
            statusLists: [
            {value: '', label: 'All'},
            {value: 'UPLOAD_SUCCESS', label: 'UPLOAD_SUCCESS'},
            {value: 'CHECSUM_SUCCESS', label: 'CHECSUM_SUCCESS'},
            {value: 'SANITYCHECK_SUCCESS', label: 'SANITYCHECK_SUCCESS'},
            {value: 'DOWNLOAD_FAILED', label: 'DOWNLOAD_FAILED'},
            {value: 'CHECKSUM_FAILED', label: 'CHECKSUM_FAILED'},
            {value: 'SANITYCHECK_FAILED', label: 'SANITYCHECK_FAILED'}
            ],
            statusIDs: '',
            statusValue: {value: '', label: 'All'},
            report_type: "summary",
            report_name: "pilot_summary",
            deviceLists: [],
            deviceIDs: '',
            deviceValue: null,
            summary_statusLists: [
            {value: '', label: 'All'},
            {value: 'pending', label: 'Pending'},
            {value: 'upgrade_success', label: 'Upgrade Success'},
            {value: 'upgrade_failed', label: 'Upgrade Failed'}

            ],
            summary_statusIDs: '',
            summary_statusValue: {value: '', label: 'All'},
        }
        this.close = this.close.bind(this);
        this.closeStoreList = this.closeStoreList.bind(this);
    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidUpdate() {
        const { listOpen } = this.state;
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (listOpen) {
                window.addEventListener('click', this.close);
            } else {
                window.removeEventListener('click', this.close);
            }
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    close() {
        this.setState({
            listOpen: false,
        });
    }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        this._getAllMerchants();
        this._getAllProducts();
        this._getAllVersion();
        this._getAllDevice();
//
         this.get_all_report("summary", "pilot_summary");
//         this._get_acq_banks();
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code, false,'');


            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: decoded.object_code,
                search_type:'innoviti',
                search_object_code: decoded.object_code,
            })
            this.ci_utid('','','',false,'');
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);

            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'merchant',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);

            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'chain',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);

            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'store'
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }
        else {
            this.unauthorize_access();
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'iDownload_report','sparcs')
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("transaction_reports")===false || reportPermissions.includes("txn_summary_report")===false ){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    get_all_report(type, name, e){
        this.setState({
            report_type:type,
            report_name: name
        })
        setTimeout(function(){
        if(name==='rollout_details') {
            this.get_rollout_details(name, type);
        }
        if(name==='rollout_summary') {
            this.get_rollout_summary(name, type);
        }
        if(name==='pilot_details') {
            this.get_pilot_details(name, type);
        }
        if(name==='pilot_summary') {
            this.get_pilot_summary(name, type);
        }

    }.bind(this), 200);

    }
    get_pilot_summary(name,type) {
        var that = this;

        var that = this;

        //disabledBody()
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
//         if(object_type === 'Merchant' && this.state.merchantID===''){
//             merchants = object_code;
//         }
//         if(object_type==='Chain' && this.state.chainID===''){
//             chains = object_code;
//         }
//         if(object_type==='Store' && this.state.storeID===''){
//             stores = object_code;
//         }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            utid: this.state.ciutidIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            previous_version: this.state.pr_versionIDs,
            upgrade_app_version: this.state.upg_versionIDs,
            operation_status: this.state.statusIDs,
            version: this.state.versionIDs,
            device: this.state.deviceIDs,
            product: this.state.productTypeIDs,
            summary_status: this.state.summary_statusIDs,
            name:name,
            type:type
        };
        if ($.fn.DataTable.isDataTable('#pilotSummaryTable')) {
            $('#pilotSummaryTable').DataTable().clear().destroy();
        }
        var pilotSummaryTable = $('#pilotSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/i-download-details",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"Pilot Id"},
                    {"data":"Product"},
                    {"data":"Package Version"},
                    {"data":"Device"},
                    {"data":"TimeStamp"},
                    {"data":"Evidence Status"},
                    {"data":"UTID Count"},
                    {"data":"Pending"},
                    {"data":"Upgrade Failed"},
                    {"data":"Roll Out %"},

                ],
                "columnDefs": [
                    {  render: function (data) {

                        if(data===null || data==='null' || data==='') {
                            return data;
                        } else {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';

                        }
                        },
                        "targets": [4],
                    },

                ],
            });
    }
    get_pilot_details(name,type) {
        var that = this;

        disabledBody()
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
//         if(object_type === 'Merchant' && this.state.merchantID===''){
//             merchants = object_code;
//         }
//         if(object_type==='Chain' && this.state.chainID===''){
//             chains = object_code;
//         }
//         if(object_type==='Store' && this.state.storeID===''){
//             stores = object_code;
//         }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            utid: this.state.ciutidIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            previous_version: this.state.pr_versionIDs,
            upgrade_app_version: this.state.upg_versionIDs,
            operation_status: this.state.statusIDs,
            name:name,
            type:type,
            version: this.state.versionIDs,
            device: this.state.deviceIDs,
            product: this.state.productTypeIDs,
            summary_status: this.state.summary_statusIDs
        };
        if ($.fn.DataTable.isDataTable('#pilotSummaryTable')) {
            $('#pilotSummaryTable').DataTable().clear().destroy();
        }
        var pilotSummaryTable = $('#pilotSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/i-download-details",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"Pilot ID"},
                    {"data":"Merchant Name"},
                    {"data": "Chain Name"},
                    {"data":"Store Name"},
                    {"data":"UTID"},
                    {"data": "Previous Version"},
                    {"data": "Upgrade Version"},
                    {"data": "iDownload Update Status"},
                    {"data": "Evidence Count"}
                ],
                "columnDefs": [
//                     {  render: function (data) {
//                             return data;
//                         },
//
//                         "targets": [ 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
//                         "className": "text-right"
//                     },

                ],
            });
    }
    get_rollout_summary(name,type) {
        var that = this;

        disabledBody()
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
//         if(object_type === 'Merchant' && this.state.merchantID===''){
//             merchants = object_code;
//         }
//         if(object_type==='Chain' && this.state.chainID===''){
//             chains = object_code;
//         }
//         if(object_type==='Store' && this.state.storeID===''){
//             stores = object_code;
//         }
        
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            utid: this.state.ciutidIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            previous_version: this.state.pr_versionIDs,
            upgrade_app_version: this.state.upg_versionIDs,
            operation_status: this.state.statusIDs,
            version: this.state.versionIDs,
            device: this.state.deviceIDs,
            product: this.state.productTypeIDs,
            summary_status: this.state.summary_statusIDs,
            name:name,
            type:type
        };
        if ($.fn.DataTable.isDataTable('#rolloutSummaryTable')) {
            $('#rolloutSummaryTable').DataTable().clear().destroy();
        }
        var rolloutSummaryTable = $('#rolloutSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/i-download-details",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"Roll Out Id"},
                    {"data":"Product"},
                    {"data":"Package Version"},
                    {"data":"Device"},
                    {"data":"TimeStamp"},
//                     {"data":"Evidence Status"},
                    {"data":"UTID Count"},
                    {"data":"Pending"},
                    {"data":"Upgrade Failed"},
                    {"data":"Roll Out %"},

                ],
                "columnDefs": [
                    {  render: function (data) {

                        if(data===null || data==='null' || data==='') {
                            return data;
                        } else {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';

                        }
                        },
                        "targets": [4],
                    },

                ],
            });
    }
    get_rollout_details(name,type) {
        var that = this;

        disabledBody()
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
//         if(object_type === 'Merchant' && this.state.merchantID===''){
//             merchants = object_code;
//         }
//         if(object_type==='Chain' && this.state.chainID===''){
//             chains = object_code;
//         }
//         if(object_type==='Store' && this.state.storeID===''){
//             stores = object_code;
//         }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            utid: this.state.ciutidIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            previous_version: this.state.pr_versionIDs,
            upgrade_app_version: this.state.upg_versionIDs,
            operation_status: this.state.statusIDs,
            name:name,
            type:type,
            version: this.state.versionIDs,
            device: this.state.deviceIDs,
            product: this.state.productTypeIDs,
            summary_status: this.state.summary_statusIDs
        };
        if ($.fn.DataTable.isDataTable('#rollOutDetailsTable')) {
            $('#rollOutDetailsTable').DataTable().clear().destroy();
        }
        var rollOutDetailsTable = $('#rollOutDetailsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/i-download-details",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"Roll Out id"},
                    {"data":"Merchant Name"},
                    {"data": "Chain Name"},
                    {"data":"Store Name"},
                    {"data":"UTID"},
                    {"data": "Previous Version"},
                    {"data": "Upgrade Version"},
                    {"data": "iDownload Update Status"},


                ],
                "columnDefs": [
//                     {  render: function (data) {
//                             return data;
//                         },
//
//                         "targets": [ 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
//                         "className": "text-right"
//                     },

                ],
            });
    }
    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        var is_enable = compareValues(midArray, this.state.active_mids);
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable,
            search_code: midArray,
            search_type:'merchant',
            storeObject:[],
            search_object_code: this.state.object_code,
        });
        // this.get_acqissuer_txn_summary(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.txnTypeIDs, '', this.state.isSettledIDs);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code,false,'');
        }
        this.ci_utid(midArray, '','',false,'');
    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable,
            search_code: cidArray,
            search_type:'chain',
            storeObject:[],
            search_object_code: this.state.merchantID,
        });
        // this.get_acqissuer_txn_summary(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.txnTypeIDs, '', this.state.isSettledIDs);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
        }
        this.ci_utid(this.state.merchantID, cidArray, '',false,'');
    }
    getChain(code, type, object_type, object_code){
        this.setState({
            chainList:[],
            is_chain_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            var is_enable = compareValues(sidArray, this.state.active_sids);
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: is_enable
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,
                        isChange: true,
                        ciutidIds: '',
                        ciutidValue: [],
                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, false, '');
        }.bind(this), 200);
    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }
    _get_issuing_banks() {
        this.setState({
            is_issuer_loading: true
        })
        axios.get(config.get('API_URL')+'/reports/get-issuing-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            let issuerList = [];
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    issuerList.push({value: issuBank.issuing_bank_name, label: issuBank.issuing_bank_name})
                });
            }
            this.setState({
                is_issuer_loading: false,
                issuerBankList:issuerList
            })
        });

    }
    change_issuer(optionSelected){
        let value='';
        let issuArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                issuArray.push(mids.value)
                var index = this.state.issuerBankList.findIndex(obj => obj.value==mids.value);
                this.state.issuerBankList.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(issuArray, this.state.active_issuer);
        this.setState({
            issuerBankIds:issuArray,
            issuerBankValue:optionSelected,
            isChange: is_enable,
        });
        //this.get_filtered_issuer_speed_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.yestSend, this.state.todSend, issuArray)

    }

    _get_acq_banks(){
        axios.get(config.get('API_URL')+'/reports/acq-banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    change_acq_banks(optionSelected){ //console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected.length<1){
            value = null;
            acqBankArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        var is_enable = compareValues(acqBankArray, this.state.active_bids);
        this.setState({
            acqBankIds:acqBankArray,
            acqBankValue:optionSelected,
            isChange: is_enable
        });
        // this.get_acqissuer_txn_summary(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs);
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY'),

        });
         if(event.type=='apply') {
             var is_date_change = false;
             if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
                 is_date_change = false;
             } else {
                 is_date_change = true;
             }
             this.setState({
                 isChange: is_date_change
             })

         }
    }


    ci_utid(mid,cid,sid,is_search, search_value) {
        let utidList = [];
        let selected_val = '';
        if(is_search===true){
            selected_val = this.state.ciutidIds
        }
        this.setState({
            ciutidList: [],
            is_utid_loading: true
        })
        axios.post(config.get('API_URL') + '/reports/get-utid/', {

                mid: mid,
                cid: cid,
                sid: sid,
                is_search:is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {

            if (Array.isArray(response.data) && response.data.length) {
                response.data.map((ci_utid, index) => {
                    utidList.push(ci_utid.utid)
                });
                if (Array.isArray(this.state.ciutidIds) && this.state.ciutidIds) {
                    utidList = utidList.filter( ( el ) => !this.state.ciutidIds.includes( el ) );
                    this.state.ciutidIds.map((ut,index) => {
                        utidList = [ut, ...utidList.filter(item => item !== ut)];
                    })

                }
                this.setState({
                    ciutidList: utidList,
                    is_utid_loading: false
                })

            } else {

                this.setState({
                    ciutidList: [],
                    is_utid_loading: false
                })
            }

        });
    }

    filterList(e){

        var value = e.target.value
        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, true, value);
        }.bind(this), 200);
    }
    toggleList() {
        this.setState({
            listOpen: !this.state.listOpen,
        });
    }

    changeUtid(utid,checked_item, e){
        let item_list = this.state.ciutidIds
        let checked_list = utid;
        //console.log(checked_list);
        if(checked_item===false) {
            const newData = [utid, ...this.state.ciutidList.filter(item => item !== utid)];
            this.setState({
                ciutidIds: [...this.state.ciutidIds,  utid],
                isChange: true,
                ciutidList: newData
            });

        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                if(item_list.length<1) {
                    item_list='';
                }
                this.setState({
                    ciutidIds: item_list,
                    isChange: true
                })
            }
        }


        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }
    iDownloadCheck(type,name, e){

    if(type==='summary' && this.state.productTypeIDs==='' && this.state.versionIDs==='' && this.state.deviceIDs==='' && this.state.statusIDs===''){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.iDownloadFile(type,name, e);
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else if(type==='summary') {
        this.iDownloadFile(type,name,e)
        } if(type==='details' && this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.utid==='' && this.state.pr_versionIDs==='' && this.state.upg_versionIDs===''&& this.state.pr_statusIDs===''){
          confirmAlert({
                //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.iDownloadFile(type,name, e);
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else if(type==='details') {
        this.iDownloadFile(type, name, e)
        }
    }
    iDownloadFile (type, name, e){

        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if(days_beet>config.get('REPORT_CSV_DAYS_LIMIT')) {
            alert("Date range too large. Please select a date range of "+ config.get('REPORT_CSV_DAYS_LIMIT')+ " days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.statusIDs,
            utid: this.state.ciutidIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            previous_version: this.state.pr_versionIDs,
            upgrade_app_version: this.state.upg_versionIDs,
            operation_status: this.state.statusIDs,
            version: this.state.versionIDs,
            device: this.state.deviceIDs,
            product: this.state.productTypeIDs,
            summary_status: this.state.summary_statusIDs,
            name:name,
            type:type

        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/summaryReport/i-download-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copytxnSummFile(response.data,name);
                this.setState({
                    fetch_data:true
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    copytxnSummFile (remotePath, name){
         var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+name+'.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }


    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
//             report_type: "summary",
//             report_name: "pilot_summary",
            is_void:1,
            file_url: '',
            rfile: '',

            ciutidIds: '',
            isChange: true,

            productTypeIDs: '',
            productTypeValue: {value: '', label: 'All'},

            versionIDs: '',
            versionValue: null,
            pr_versionIDs: '',
            pr_versionValue: null,
            upg_versionIDs: '',
            upg_versionValue: null,
            statusIDs: '',
            statusValue: {value: '', label: 'All'},
            deviceIDs: '',
            deviceValue: null,
            summary_statusIDs: '',
            summary_statusValue: {value: '', label: 'All'},

        })

//         setTimeout(function(){
//             this.componentDidMount()
//         }.bind(this), 200);
    }
    _getAllProducts(){
        axios.post(config.get('API_URL')+'/filters/get-products/',
        {
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var pList = [{value: "", label: "All"}]
                response.data.map((product, index) => {
                    pList.push({value: product.product_name, label: product.product_name})
                });
                this.setState({
                    productTypeLists:pList,

                })
            }
        });
    }
    changeProductType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        var is_enable = compareValues(value, this.state.active_product);
        this.setState({
            productTypeIDs:value,
            productTypeValue:optionSelected,
            isChange: is_enable
        });
    }
    _getAllVersion(){
        axios.post(config.get('API_URL')+'/filters/get-version/',
        {
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var pList = []
                response.data.map((version, index) => {
                    pList.push({value: version.version, label: version.version})
                });
                this.setState({
                    versionLists:pList,
                })
            }
        });
    }

    _getAllDevice(){
        axios.post(config.get('API_URL')+'/filters/get-device/',
        {
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var pList = []
                response.data.map((dname, index) => {
                    pList.push({value: dname.device_name, label: dname.device_name})
                });
                this.setState({
                    deviceLists:pList,
                })
            }
        });
    }
    changeVersion(optionSelected){
        let value='';
        let vArray = [];
        if(optionSelected.length<1){
            value = null;
            vArray = '';
        }
        else{
            optionSelected.map((vs, i) => {
                vArray.push(vs.value)
            });
        }

        this.setState({
            versionIDs:vArray,
            versionValue:optionSelected,
            isChange: true,
        });

    }

    changePreVersion(optionSelected){
        let value='';
        let pArray = [];
        if(optionSelected.length<1){
            value = null;
            pArray = '';
        }
        else{
            optionSelected.map((vs, i) => {
                pArray.push(vs.value)
            });
        }

        this.setState({
            pr_versionIDs:pArray,
            pr_versionValue:optionSelected,
            isChange: true,
        });

    }

    changeUpgVersion(optionSelected){
        let value='';
        let uArray = [];
        if(optionSelected.length<1){
            value = null;
            uArray = '';
        }
        else{
            optionSelected.map((vs, i) => {
                uArray.push(vs.value)
            });
        }

        this.setState({
            upg_versionIDs:uArray,
            upg_versionValue:optionSelected,
            isChange: true,
        });

    }

    changeDevice(optionSelected){
        let value='';
        let dArray = [];
        if(optionSelected.length<1){
            value = null;
            dArray = '';
        }
        else{
            optionSelected.map((vs, i) => {
                dArray.push(vs.value)
            });
        }

        this.setState({
            deviceIDs:dArray,
            deviceValue:optionSelected,
            isChange: true,
        });

    }

    changeStatus(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;

        this.setState({
            statusIDs:value,
            statusValue:optionSelected,
            isChange: true
        });
    }

    changeSummaryStatus(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;

        this.setState({
            summary_statusIDs:value,
            summary_statusValue:optionSelected,
            isChange: true
        });
    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "30px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "35px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const utid_lists = this.state.ciutidList.map((utid_object, index) => {
            var chk_input = <input type='checkbox' checked={false}/>
            var activeCls = 'dd-list-item';
            var checked_item = false;
            if(this.state.ciutidIds.includes(utid_object) === true){
                chk_input = <input type='checkbox' checked={true}/>
                activeCls = "dd-list-item dd-list-active";
                checked_item = true;
            }
            return (
                <li key={index} className={activeCls} onClick={this.changeUtid.bind(this, utid_object,checked_item)}>
                    {chk_input}
                    &nbsp;&nbsp;{utid_object}
                </li>
            )
        })
        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })
        return(
           
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">iDownload Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                    <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                        <div><label> Date Filter: </label></div>
                                        <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                         onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}
                                                         minDate={this.state.dateFromLimit}
                                                         >
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                            <input type="text" name="dateRange" className="form-control dateRangeInput"
                                                   value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                        </DateRangePicker>
                                    </div>
                                    {this.state.report_type==='details'?
                                    <React.Fragment>
                                    {this.state.merchant_list_box ===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Merchants</label>
                                            <ReactMultiSelectCheckboxes name="merchants"
                                                isMulti
                                                                        isLoading={this.state.is_merchant_loading}
                                                value={this.state.merchantValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeMerchant.bind(this,'')}
                                                options={this.state.merchantList}
                                                placeholderButtonLabel="Select [Merchant]"
                                            />

                                            <div className="clearfix"></div>
                                        </div> : null}
                                    {this.state.chain_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Chain </label>
                                            <ReactMultiSelectCheckboxes name="chain"
                                                isMulti
                                                isLoading={this.state.is_chain_loading}
                                                components={{ MenuList }}
                                                value={this.state.chainValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeChain.bind(this,'')}
                                                options={this.state.chainList}
                                                placeholderButtonLabel="Select [Chain]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>: null }
                                    {this.state.store_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5" >
                                            <label> Store: </label>
                                            <div className="dd-wrapper">
                                                <div className="dd-header" onClick={() => this.storeToggleList()}>
                                                    {this.state.storeID==''?
                                                        <div className="dd-header-title">{this.state.storeHeaderTitle}</div>:
                                                        <div className="dd-header-title">{this.state.storeID.length} Selected</div>
                                                    }

                                                    <i className="fa fa-angle-down"></i>
                                                </div>
                                                {this.state.storeListOpen ===true?
                                                    <div
                                                        role="list"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <input
                                                            className="dd-list-search-bar"
                                                            placeholder="Search"
                                                            onChange={(e) => this.storeFilterList(e)}
                                                        />
                                                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                        {/*<div className="dd-scroll-list">*/}
                                                        <ul className="dd-list">
                                                            {this.state.is_store_loading===true?
                                                                <li>
                                                                    <BeatLoader
                                                                        css={override}
                                                                        sizeUnit={"px"}
                                                                        size={5}
                                                                        color={'#666666'}
                                                                        loading={this.state.is_store_loading}
                                                                    />
                                                                </li>: null}
                                                            {store_lists}

                                                        </ul> </div>: null }
                                                {/*</div>*/}
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <div className="dd-wrapper">
                                                    <div className="dd-header" onClick={() => this.toggleList()}>
                                                        {this.state.ciutidIds==''?
                                                            <div className="dd-header-title">{this.state.headerTitle}</div>:
                                                            <div className="dd-header-title">{this.state.ciutidIds.length} Selected</div>
                                                        }

                                                        <i className="fa fa-angle-down"></i>
                                                    </div>
                                                    {this.state.listOpen ===true?
                                                        <div
                                                            role="list"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <input
                                                                className="dd-list-search-bar"
                                                                placeholder="Search"
                                                                onChange={(e) => this.filterList(e)}
                                                            />
                                                            <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                            {/*<div className="dd-scroll-list">*/}
                                                            <ul className="dd-list">
                                                                {this.state.is_utid_loading===true?
                                                                    <li>
                                                                        <BeatLoader
                                                                            css={override}
                                                                            sizeUnit={"px"}
                                                                            size={5}
                                                                            color={'#666666'}
                                                                            loading={this.state.is_utid_loading}
                                                                        />
                                                                    </li>: null}
                                                                {utid_lists}

                                                            </ul> </div>: null }
                                                    {/*</div>*/}
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Pr. Version </label>
                                                <ReactMultiSelectCheckboxes name="pr_version"
                                                    isMulti
                                                    components={{ MenuList }}
                                                    value={this.state.pr_versionValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changePreVersion.bind(this)}
                                                    options={this.state.versionLists}
                                                    placeholderButtonLabel="Select [Pr. Version]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Upgrade Version </label>
                                                <ReactMultiSelectCheckboxes name="pr_version"
                                                    isMulti
                                                    components={{ MenuList }}
                                                    value={this.state.upg_versionValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeUpgVersion.bind(this)}
                                                    options={this.state.versionLists}
                                                    placeholderButtonLabel="Select [Upgrade Version]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Status </label>
                                                <Select name="status"

                                                value={this.state.statusValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeStatus.bind(this)}
                                                options={this.state.statusLists}
                                                placeholderButtonLabel="All"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            </React.Fragment>:null}
                                            {this.state.report_type==='summary'?
                                            <React.Fragment>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Product Type </label>
                                                <Select name="product_type"
                                                    value={this.state.productTypeValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeProductType.bind(this)}
                                                    options={this.state.productTypeLists}
                                                    placeholder="[Product Type]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Package Version </label>
                                                <ReactMultiSelectCheckboxes name="version"
                                                    isMulti
                                                    components={{ MenuList }}
                                                    value={this.state.versionValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeVersion.bind(this)}
                                                    options={this.state.versionLists}
                                                    placeholderButtonLabel="Select [Version]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Device </label>
                                                <ReactMultiSelectCheckboxes name="device"
                                                    isMulti
                                                    components={{ MenuList }}
                                                    value={this.state.deviceValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeDevice.bind(this)}
                                                    options={this.state.deviceLists}
                                                    placeholderButtonLabel="Select [Device]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Status </label>
                                                <Select name="summary_status"

                                                value={this.state.summary_statusValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeSummaryStatus.bind(this)}
                                                options={this.state.summary_statusLists}
                                                placeholderButtonLabel="All"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            </React.Fragment>:null}


                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_all_report.bind(this,this.state.report_type, this.state.report_name)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                    </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs>
                                        <TabList>
                                            <Tab onClick={()=>this.get_all_report('summary','pilot_summary')}>Pilot Summary</Tab>
                                            <Tab onClick={()=>this.get_all_report('details','pilot_details')}>Pilot Detail</Tab>
                                            <Tab onClick={()=>this.get_all_report('summary','rollout_summary')}>Roll Out Summary</Tab>
                                            <Tab onClick={()=>this.get_all_report('details','rollout_details')}>Roll Out Detail</Tab>
                                        </TabList>

                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.iDownloadCheck.bind(this, this.state.report_type, this.state.report_name)}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="pilotSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Pilot Id</th>
                                                <th>Product</th>
                                                <th>Package Version</th>
                                                <th>Device</th>
                                                <th>TimeStamp</th>
                                                <th>Evidence Status</th>
                                                <th>UTID Count</th>
                                                <th>Pending</th>
                                                <th>Upgrade Failed</th>
                                                <th>Roll Out %</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>

                                        </TabPanel>
                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.iDownloadCheck.bind(this, this.state.report_type, this.state.report_name)}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="pilotSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Pilot id</th>
                                                    <th>Merchant Name</th>
                                                    <th>Chain Name</th>
                                                    <th>Store Name</th>
                                                    <th>UTID</th>
                                                    <th>Previous Version</th>
                                                    <th>Upgrade Version</th>
                                                    <th>iDownload Update Status</th>
                                                    <th>Evidence Count</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                        </TabPanel>
                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.iDownloadCheck.bind(this, this.state.report_type, this.state.report_name)}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="rolloutSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Roll Out Id</th>
                                                <th>Product</th>
                                                <th>Package Version</th>
                                                <th>Device</th>
                                                <th>TimeStamp</th>
{/*                                                 <th>Evidence Status</th> */}
                                                <th>UTID Count</th>
                                                <th>Pending</th>
                                                <th>Upgrade Failed</th>
                                                <th>Roll Out %</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                        </TabPanel>
                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.iDownloadCheck.bind(this, this.state.report_type, this.state.report_name)}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="rollOutDetailsTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Roll Out id</th>
                                                    <th>Merchant Name</th>
                                                    <th>Chain Name</th>
                                                    <th>Store Name</th>
                                                    <th>UTID</th>
                                                    <th>Previous Version</th>
                                                    <th>Upgrade Version</th>
                                                    <th>iDownload Update Status</th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                        </TabPanel>
                                        </Tabs>
                                        <div className="clearfix"></div>

                                    </div>

                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( IdownloadReport);